import dayjs from "dayjs";

// Booking times are stored as decimal hours (8.5 === 8:30 am) to keep math simple.
export const fmtTime = (h) => {
  const total = Math.round(h * 60);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  const ap = hh >= 12 && hh < 24 ? "pm" : "am";
  let display = hh % 12;
  if (display === 0) display = 12;
  return mm ? `${display}:${String(mm).padStart(2, "0")} ${ap}` : `${display} ${ap}`;
};

export const toDayjs = (dec) =>
  dayjs()
    .hour(Math.floor(dec) % 24)
    .minute(Math.round((dec - Math.floor(dec)) * 60))
    .second(0);

export const fromDayjs = (d) => (d ? d.hour() + d.minute() / 60 : 0);

// Human-readable label for the organization's office_hours setting:
// {start, end, days: [...]}, one time range applied to the listed days.
export const officeHoursSummary = (value) => {
  if (!value || !value.days?.length) return "Closed all week";
  return `${fmtTime(value.start)}–${fmtTime(value.end)} (${value.days.join(", ")})`;
};
